import type { Program } from 'models';
import { useCallback } from 'react';

export const useGetPriceProperties = () =>
  useCallback((program: Pick<Program, 'price' | 'priceOption' | 'sponsors'>) => {
    const totalPrice = Number.parseFloat(String(program.price)) || 0;

    const paidBySponsors =
      program.sponsors?.reduce((previous, current) => previous + (Number.parseFloat(String(current.price)) || 0), 0) ??
      0;
    const missingToPay = Math.max(totalPrice - paidBySponsors, 0);

    return {
      isContactUs: program.priceOption === 'contact_us',
      isFree: program.priceOption === 'free',
      missingToPay,
      paidBySponsors,
      totalPrice,
    };
  }, []);
